export const PubChemLink = (pubchem) => <a href={"https://pubchem.ncbi.nlm.nih.gov/compound/" + pubchem.value} target="_blank" rel="noopener noreferrer"> {pubchem.value} </a>
